import React from 'react';
import { IconSvgProps } from '@models/common';

const ExternalLink: React.FC<IconSvgProps> = ({ size = 14 }) => (
  <svg
    width={size}
    height={size}
    xmlns='http://www.w3.org/2000/svg'
    fill='none'
    viewBox='0 0 14 14'>
    <path
      stroke='var(--color-main)'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='1.25'
      d='M10.5 7.583v3.5a1.167 1.167 0 0 1-1.167 1.167H2.917a1.167 1.167 0 0 1-1.167-1.167V4.667A1.167 1.167 0 0 1 2.917 3.5h3.5M8.75 1.75h3.5v3.5M5.833 8.167 12.25 1.75'
    />
  </svg>
);

export default ExternalLink;
